import React from "react";
import "./courses.scss";
export const Courses = ({ data }) => {
  return (
    <div className="col   col-md-4">
      {" "}
      <div className="cources">
        <img className="" src={data.img} alt="Scholar" width="100%" />

        <p style={{ marginTop: "10px" }}>
          Course Code: <strong>{data.courseCode}</strong>
        </p>
        <h5>{data.courseTitle}</h5>
        <div className="flexy flexyM">
          {" "}
          <p style={{ flexGrow: "1" }}>
            By:<span>{data.courseHandler}</span>
          </p>
          <p>
            Unit Load:<span>{data.unitLoad}</span>
          </p>
        </div>
        {/* <p>{data.courseDetail}</p> */}
      </div>
    </div>
  );
};
